require('../proposals/reflect-metadata');

module.exports = require('./0');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/stage/pre.js
// module id = pNg3
// module chunks = 0